export default "__VITE_ASSET__T1DUPmnU__"